module.exports = __webpack_public_path__ + "img/ctaBackgroundMobile.d86a4964.svg";